import { useEffect, useState } from "react";
import { api } from "../api/client";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";

export default function AuditLog() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    async function load() {
      try {
        const logs = await api("/admin/audit");
        setItems(logs);
      } catch (err) {
        console.error("Failed to load audit log:", err);
      }
    }
    load();
  }, []);

  return (
    <Box>
      <Typography variant="h6" mb={1}>Audit Log</Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        Recent administrative actions and system events.
      </Typography>
      <List>
        {items.map((e, i) => (
          <ListItem key={i} divider>
            <ListItemText
              primary={`${new Date(e.ts).toLocaleString()} — ${e.action}`}
              secondary={JSON.stringify(e.payload)}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
